import type { IconNode } from '../types';

/**
 * @name kettle-electric
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMiAxNHYtNGMwLTEuNyAxLjMtMyAzLTNoMTZ2MmMwIDItMS41IDMuNy0zLjUgMy45IiAvPgogIDxwYXRoIGQ9Ik0xMSA3djciIC8+CiAgPHBhdGggZD0iTTEyIDJDOS4yIDIgNyA0LjIgNyA3bC0uOCA5Yy0uMSAxLjEuNyAyIDEuOCAyaDhjMS4xIDAgMS45LS45IDEuOC0yYTE2MDcuMSAxNjA3LjEgMCAwIDEtLjgtOWMwLTIuOC0yLjItNS01LTUiIC8+CiAgPHBhdGggZD0iTTYgMjJoMTIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/kettle-electric
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const kettleElectric: IconNode = [
  ['path', { d: 'M2 14v-4c0-1.7 1.3-3 3-3h16v2c0 2-1.5 3.7-3.5 3.9', key: '1bzsi7' }],
  ['path', { d: 'M11 7v7', key: 'o812ip' }],
  [
    'path',
    {
      d: 'M12 2C9.2 2 7 4.2 7 7l-.8 9c-.1 1.1.7 2 1.8 2h8c1.1 0 1.9-.9 1.8-2a1607.1 1607.1 0 0 1-.8-9c0-2.8-2.2-5-5-5',
      key: 'jhnnf9',
    },
  ],
  ['path', { d: 'M6 22h12', key: '14i54f' }],
];

export default kettleElectric;
